module.exports = "<p>\r\n  breakinvestment works!\r\n</p>\r\n"